import React, { useState } from "react";
import API_BASE_URL from "./config";
import SocialAuthButtons from "./components/SocialAuthButtons";
import "./Login.css";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/api/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.message || "Login failed");
        setLoading(false);
        return;
      }

      // Store token and email in localStorage
      localStorage.setItem("token", data.token);
      localStorage.setItem("userEmail", data.user.email);
      localStorage.setItem("userId", data.user.id);
      localStorage.setItem("userRole", data.user.role || "user");
      // Plan-gated menu flags are per-account; never carry them across logins.
      sessionStorage.removeItem("crmAllowed");
      if (data.user.studio_slug) localStorage.setItem("studioSlug", data.user.studio_slug);
      if (data.user.studio_name) localStorage.setItem("studioName", data.user.studio_name);

      const plan = new URLSearchParams(window.location.search).get("plan");
      if (plan) {
        window.location.href = `/subscribe/${plan}`;
      } else {
        window.location.href = data.user.role === "super_admin" ? "/admin" : "/dashboard";
      }
    } catch (err) {
      setError("Error connecting to server");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <a href="/" className="login-logo-link">
          <img src={process.env.PUBLIC_URL + "/photentra-logo.png"} alt="Photentra" className="login-logo" />
        </a>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter your email"
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <SocialAuthButtons dividerText="or continue with" />

        <div className="forgot-password-link">
          <a href="/forgot-password">Forgot Password?</a>
        </div>

        <div className="signup-link">
          Don't have an account?{" "}
          <a href={(() => {
            const plan = new URLSearchParams(window.location.search).get("plan");
            return plan ? `/signup?plan=${plan}` : "/signup";
          })()}>
            Sign up here
          </a>
        </div>
      </div>
    </div>
  );
}

export default Login;
